import moment from 'moment-timezone';

export const hasCommonProps = (object1, object2) => {
    for (const field in object1) {
        if (object1.hasOwnProperty(field) && object2.hasOwnProperty(field)) return true;
    }
    return false;
};


// WEBPACK FOOTER //
// ./src/client/src/utils/Util.js